/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { Component, Optional } from '@angular/core';
import { RacuniViewComponent } from './racuni.view.component';

@Component({
    selector: 'kb-top-section',
    templateUrl: './topSection.html',
})
export class TopSectionComponent {
    constructor(@Optional() public parent: RacuniViewComponent) {}
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/transparentnost/racuni/topSection.ts